module.exports = __webpack_public_path__ + "static/sifter-abe5d02b67631c1813a1ae16754971bf.svg";